import {Component, OnInit} from '@angular/core';
import {FieldTypeEnum} from '../../../../projects/mydocma/dynamic-form/src/lib/dynamic-field/field-type.enum';
import {DynamicFormConfig} from '../../../../projects/mydocma/dynamic-form/src/lib/dynamic-form/dynamic-form.config';
import {DynamicFormReadyEvent} from '../../../../projects/mydocma/dynamic-form/src/lib/events/dynamic-form-ready.event';
import {UntypedFormGroup} from '@angular/forms';
import {fieldsMap} from '../../common/fields-map';

@Component({
    selector: 'app-form-config',
    templateUrl: './form-performance.component.html',
    styleUrls: ['./form-performance.component.scss']
})
export class FormPerformanceComponent implements OnInit {

    public typeFields = [
        {
            id: 'textFieldsCount',
            name: 'textFieldsCount',
            type: FieldTypeEnum.number,
            label: 'add-form-config.textFieldsCount',
        },
        {
            id: 'textAreaFieldsCount',
            name: 'textAreaFieldsCount',
            type: FieldTypeEnum.number,
            label: 'add-form-config.textAreaFieldsCount'
        },
        {
            id: 'numberFieldsCount',
            name: 'numberFieldsCount',
            type: FieldTypeEnum.number,
            label: 'add-form-config.numberFieldsCount',
        },
        {
            id: 'selectFieldsCount',
            name: 'selectFieldsCount',
            type: FieldTypeEnum.number,
            label: 'add-form-config.selectFieldsCount',
        },
        {
            id: 'checkboxFieldsCount',
            name: 'checkboxFieldsCount',
            type: FieldTypeEnum.number,
            label: 'add-form-config.checkboxFieldsCount'
        },
        {
            id: 'optionFieldsCount',
            name: 'optionFieldsCount',
            type: FieldTypeEnum.number,
            label: 'add-form-config.optionFieldsCount'
        },
        {
            id: 'dateFieldsCount',
            name: 'dateFieldsCount',
            type: FieldTypeEnum.number,
            label: 'add-form-config.dateFieldsCount'
        },
        {
            id: 'datetimeFieldsCount',
            name: 'datetimeFieldsCount',
            type: FieldTypeEnum.number,
            required: true,
            label: 'add-form-config.datetimeFieldsCount',
        },
        {
            id: 'timeFieldsCount',
            name: 'timeFieldsCount',
            type: FieldTypeEnum.number,
            label: 'add-form-config.timeFieldsCount',
        },
        {
            id: 'buttonFieldsCount',
            name: 'buttonFieldsCount',
            type: FieldTypeEnum.number,
            label: 'add-form-config.buttonFieldsCount'
        },
        {
            id: 'iconFieldsCount',
            name: 'iconFieldsCount',
            type: FieldTypeEnum.number,
            required: true,
            label: 'add-form-config.iconFieldsCount'
        },
        {
            id: 'imageFieldsCount',
            name: 'imageFieldsCount',
            type: FieldTypeEnum.number,
            label: 'add-form-config.imageFieldsCount'
        },
        {
            id: 'generateRandom',
            name: 'generateRandom',
            type: FieldTypeEnum.button,
            label: 'add-form-config.generateRandom',
            click: this.generateRandom.bind(this)
        },
        {
            id: 'addToForm',
            name: 'addToForm',
            type: FieldTypeEnum.button,
            label: 'add-form-config.addToForm',
            click: this.addFields.bind(this)
        },
        {
            id: 'replaceInForm',
            name: 'replaceInForm',
            type: FieldTypeEnum.button,
            label: 'add-form-config.replaceInForm',
            click: this.newFields.bind(this)
        }
    ];


    public performanceFields = [];
    public formPerformanceConfig: DynamicFormConfig;
    public formTypesConfig: any;
    private fieldIdToFieldTypeEnum = new Map<string, FieldTypeEnum>([
        ['buttonFieldsCount', FieldTypeEnum.button],
        ['checkboxFieldsCount', FieldTypeEnum.checkbox],
        ['dateFieldsCount', FieldTypeEnum.date],
        ['datetimeFieldsCount', FieldTypeEnum.datetime],
        ['iconFieldsCount', FieldTypeEnum.icon],
        ['imageFieldsCount', FieldTypeEnum.image],
        ['numberFieldsCount', FieldTypeEnum.number],
        ['selectFieldsCount', FieldTypeEnum.select],
        ['textFieldsCount', FieldTypeEnum.text],
        ['textAreaFieldsCount', FieldTypeEnum.textarea],
        ['timeFieldsCount', FieldTypeEnum.time],
        ['optionFieldsCount', FieldTypeEnum.option]
    ]);
    private formData: DynamicFormReadyEvent;
    private formGroup: UntypedFormGroup;
    private counter = 0;

    public ngOnInit() {
        this.formTypesConfig = {
            layouts: [],
            name: '',
            fields: this.typeFields
        };

        this.formPerformanceConfig = {
            layouts: [],
            name: '',
            fields: this.performanceFields
        };
    }

    public onReady(param) {
        this.formData = param;

        this.formGroup = param.dynamicFormService.formGroup;
    }

    public generateRandom() {
        Object.keys(this.formGroup.controls).forEach((field) => {
            this.formGroup.get(field).setValue(100);
        });
    }

    public addFields() {
        Object.keys(this.formGroup.controls).forEach((field) => {
            if (['generateRandom', 'addToForm', 'replaceInForm'].indexOf(field) > -1) {
                return;
            }
            if (!this.formGroup.get(field).value) {
                return;
            }

            for (let i = 0; i < this.formGroup.get(field).value; i++) {
                const fieldConfig = fieldsMap.get(this.fieldIdToFieldTypeEnum.get(field));
                fieldConfig.name = `${fieldConfig.name}${this.counter++}`;

                this.performanceFields.push(fieldsMap.get(this.fieldIdToFieldTypeEnum.get(field)));
            }
        });

        this.formPerformanceConfig = {
            layouts: [],
            name: '',
            fields: this.performanceFields
        };
    }

    public newFields() {
        this.performanceFields = [];

        this.addFields();
    }
}
